import React from 'react';
import { Tabs, Tab } from '@mui/material';
import { colors, typography } from '../../../styles/theme';
import {
  FILTER_ACCENT,
  FILTER_ACCENT_27,
  filterPanelTabsSx,
} from './FilterPanel.styles';
import { FILTER_PANEL_TAB } from '../../data/parcelFilterContract';

const badgeStyle = ({ active = false }) => ({
  minWidth: '16px',
  height: '16px',
  padding: '0 5px',
  marginLeft: '6px',
  borderRadius: '999px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: active ? FILTER_ACCENT_27 : 'rgba(255,255,255,0.08)',
  color: active ? FILTER_ACCENT : colors.textSecondary,
  fontSize: '10px',
  fontFamily: typography.fontFamily.primary,
  fontWeight: typography.fontWeight.medium,
  lineHeight: 1,
});

const TABS = [
  { id: FILTER_PANEL_TAB.lot, label: 'Lote' },
  { id: FILTER_PANEL_TAB.units, label: 'Unidades' },
];

/**
 * Tabs Lote / Unidades del panel de filtros.
 * Mismo patrón que el detalle de lote: texto + subrayado, no botón relleno.
 */
const FilterPanelTabs = ({
  value = FILTER_PANEL_TAB.lot,
  lotCount = 0,
  unitsCount = 0,
  onChange,
}) => (
  <Tabs
    value={value}
    onChange={(_, next) => onChange?.(next)}
    variant="fullWidth"
    aria-label="Filtrar por lote o unidades"
    sx={filterPanelTabsSx}
  >
    {TABS.map((tab) => {
      const active = value === tab.id;
      const count = tab.id === FILTER_PANEL_TAB.lot ? lotCount : unitsCount;
      return (
        <Tab
          key={tab.id}
          value={tab.id}
          disableRipple
          label={(
            <span style={{ display: 'inline-flex', alignItems: 'center' }}>
              {tab.label}
              {count > 0 && (
                <span style={badgeStyle({ active })}>{count}</span>
              )}
            </span>
          )}
        />
      );
    })}
  </Tabs>
);

export default FilterPanelTabs;
